<template>
  <div class="kb-video-container">
    <!-- 顶部导航栏 -->
    <div class="nav-bar">
      <div class="back-btn" @click="goBack">
        <i
          class="el-icon-arrow-left back-icon"
          style="font-size: 20px;font-weight: 600;"
        />
      </div>
      <div class="nav-title">口播视频</div>
      <div class="nav-actions">
        <!-- 保留空位，与左侧返回按钮平衡 -->
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="content">
      <!-- 视频添加区域 -->
      <div class="video">
        <!-- 标题输入区域 -->
        <div class="title-section">
          <div class="title-label">作品名称</div>
          <div class="title-input-wrapper">
            <input
              v-model="workName"
              type="text"
              class="title-input"
              placeholder="请输入作品名称（1-20字符）"
              maxlength="20"
            />
            <div class="char-count">{{ workName.length }}/20</div>
          </div>
        </div>
        <!-- 视频回显区域 -->
        <div v-if="uploadedVideo.url" class="video-preview-section">
          <div class="video-preview-wrapper" @click="showLargeVideo">
            <video
              ref="videoPreview"
              class="video-preview"
              controls
              :src="uploadedVideo.url"
            ></video>
            <div class="zoom-icon">
              <i class="el-icon-full-screen"></i>
            </div>
          </div>
        </div>
        <!-- 视频添加按钮（仅在未上传时显示） -->
        <div v-else class="video-add-section">
          <div class="add-video-btn" @click="showVideoModal">
            <div class="plus-icon">+</div>
          </div>
          <div class="video-tip">添加视频</div>
          <div class="video-format">
            仅支持mp4/mov/wmv/wav格式，时长不超过2分钟
          </div>
        </div>
      </div>

      <div class="mode">
        <!-- 生成模式选择 -->
        <!-- <div class="mode-section">
          <div class="section-title">生成模式</div>
          <div class="mode-options">
            <div class="mode-option">高品质</div>
            <div class="mode-option">尊享</div>
            <div class="mode-option">标准</div>
          </div>
        </div> -->

        <!-- 添加配音选择 -->
        <div class="voice-section">
          <div class="section-title">添加配音</div>
          <div class="voice-options">
            <div class="voice-option" @click="setActiveOption('py')">
              复刻配音
              <div class="voice-status" :class="{ added: hasVoiceId }">
                {{ hasVoiceId ? "已添加" : "未添加" }}
              </div>
            </div>
            <!-- <div class="voice-option" @click="setActiveOption('video-ai')">
              AI主播配音
            </div> -->
            <!-- <div class="voice-option" @click="setActiveOption('folder-select')">
              从文件夹选择
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 底部生成按钮 -->
    <div class="bottom-btn-section">
      <!-- 生成记录 -->
      <div class="record-section" @click="toRecords('1')">
        <div class="record-title">生成记录</div>
      </div>
      <el-button type="primary" class="generate-btn" @click="generateVideo"
        >生成视频</el-button
      >
    </div>

    <!-- 文件输入元素（隐藏） -->
    <input
      ref="fileInput"
      type="file"
      accept="video/*"
      capture="environment"
      style="display: none;"
      @change="handleFileSelect"
    />
    <input
      ref="cameraInput"
      type="file"
      accept="video/*"
      capture="user"
      style="display: none;"
      @change="handleFileSelect"
    />

    <!-- 视频放大播放模态框 -->
    <div v-if="showLargeVideoModal" class="large-video-modal">
      <div class="modal-overlay" @click="hideLargeVideo"></div>
      <div class="large-video-content">
        <div class="large-video-body">
          <video
            ref="largeVideo"
            class="large-video"
            controls
            autoplay
            :src="uploadedVideo.url"
          ></video>
        </div>
      </div>
    </div>

    <!-- 上传参考视频模态框 -->
    <div v-if="showModal" class="video-modal">
      <div class="modal-overlay" @click="showModal = false"></div>
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">上传参考视频</div>
          <div class="modal-close" @click="showModal = false">×</div>
        </div>
        <div class="modal-body">
          <div class="video-format-tip">
            仅支持mp4/mov/wmv/wav格式，时长不超过2分钟
          </div>
          <div class="reference-videos">
            <div class="reference-item">
              <div class="reference-img">
                <img src="../../assets/video/jimeng.png" alt="正脸正拍" />
                <!-- 备注：实际使用时需要将文件重命名为pretty-girl-face.png -->
              </div>
              <div class="reference-tag valid">
                <!-- <img src="../../assets/video/check-circle.png" alt="有效" /> -->
                <span>正脸正拍</span>
              </div>
            </div>
            <div class="reference-item">
              <div class="reference-img">
                <img src="../../assets/video/jimeng_1.png" alt="面部有干扰" />
                <!-- 备注：实际使用时需要将文件重命名为face-with-interference.png -->
              </div>
              <div class="reference-tag invalid">
                <!-- <img src="../../assets/video/close-circle.png" alt="无效" /> -->
                <span>面部有干扰</span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <el-button class="upload-btn cancel" @click="handleAlbumImport"
            >相册导入</el-button
          >
          <el-button
            type="primary"
            class="upload-btn"
            @click="handleCameraCapture"
            >直接拍摄</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { workUpload, anchorVideoChatVoiceRetalk } from "@/api/video";
import { toRaw } from "vue";

export default {
  name: "KbVideo",
  data() {
    return {
      showModal: false,
      uploadedVideo: {
        url: "",
        name: "",
        duration: 0,
        id: "", // 添加视频ID
      },
      showLargeVideoModal: false,
      hasVoiceId: false,
      voiceId: "", // 音频ID
      workName: "", // 作品名称
    };
  },
  methods: {
    toRecords(status) {
      this.$router.push({
        name: "records",
        query: {
          type: status,
        },
      });
    },
    goBack() {
      // 返回上一页逻辑
      this.$router.back();
    },
    showVideoModal() {
      this.showModal = true;
    },
    setActiveOption(option) {
      // 设置当前激活的选项逻辑
      this.$router.push({ name: option });
    },
    // 从相册导入
    handleAlbumImport() {
      this.showModal = false;
      // 触发文件选择器（相册）
      this.$refs.fileInput.click();
    },
    // 直接拍摄
    handleCameraCapture() {
      this.showModal = false;
      // 触发相机
      this.$refs.cameraInput.click();
    },
    // 处理文件选择
    handleFileSelect(event) {
      const file = event.target.files[0];
      if (!file) return;

      // 创建视频元素验证时长和获取信息
      const video = document.createElement("video");
      video.preload = "metadata";
      video.onloadedmetadata = () => {
        // 验证视频时长
        if (video.duration > 120) {
          this.$message.error("视频时长不能超过2分钟");
          URL.revokeObjectURL(video.src);
          return;
        }

        // 获取视频信息
        const videoInfo = {
          file: file,
          name: file.name,
          duration: video.duration,
        };

        // 所有验证通过，上传视频
        this.uploadVideo(videoInfo);

        // 释放URL对象
        URL.revokeObjectURL(video.src);
      };

      // 设置视频源
      video.src = URL.createObjectURL(file);
    },

    // 格式化视频时长
    formatDuration(duration) {
      const minutes = Math.floor(duration / 60);
      const seconds = Math.floor(duration % 60);
      return `${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    },
    // 上传视频到服务器
    async uploadVideo(videoInfo) {
      try {
        // 从地址栏获取phone参数作为userId
        const userId = localStorage.getItem("userMes") ? (eval('(' + localStorage.getItem("userMes") + ')').phone) : "";

        const formData = new FormData();
        formData.append("file", videoInfo.file);
        formData.append("userId", userId);

        this.$message({ message: "正在上传视频...", type: "info" });

        // 调用workUpload接口
        const response = await workUpload(formData);

        // 添加调试信息，查看完整响应
        console.log("上传视频响应:", response);

        // 修复成功判断条件，根据实际接口返回格式调整
        if (response && response.data.data.fileUrl) {
          this.$message({ message: "视频上传成功", type: "success" });

          // 保存上传成功的视频信息
          this.uploadedVideo = {
            url: response.data.data.fileUrl, // 直接使用返回的fileUrl
            name: videoInfo.file.name,
            id: response.data.data.id, // 保存视频ID
          };
        } else {
          this.$message.error(
            "视频上传失败：" + (response.message || "未知错误")
          );
        }
      } catch (error) {
        console.error("上传视频失败:", error);
        this.$message.error("视频上传失败，请重试");
      }
    },
    // 显示放大视频
    showLargeVideo() {
      this.showLargeVideoModal = true;
      // 延迟播放放大后的视频
      this.$nextTick(() => {
        if (this.$refs.largeVideo) {
          this.$refs.largeVideo.play();
        }
      });
    },
    // 生成视频
    async generateVideo() {
      try {
        // 验证必要参数
        const userId = localStorage.getItem("userMes") ? (eval('(' + localStorage.getItem("userMes") + ')').phone) : "";
        if (!userId) {
          this.$message.error("用户ID不存在，请重新登录");
          return;
        }

        if (!this.uploadedVideo.id) {
          this.$message.error("请先上传视频");
          return;
        }

        if (!this.voiceId) {
          this.$message.error("请先选择配音");
          return;
        }

        // 验证作品名称
        if (!this.workName || this.workName.trim().length === 0) {
          this.$message.error("请输入作品名称");
          return;
        }

        if (this.workName.length > 50) {
          this.$message.error("作品名称不能超过50个字符");
          return;
        }

        // 直接调用生成接口
        this.callGenerateVideo(userId, this.workName.trim());
      } catch (error) {
        console.error("生成视频失败:", error);
        this.$message.error("生成视频失败，请重试");
      }
    },
    // 调用生成视频接口
    async callGenerateVideo(userId, workName) {
      try {
        this.$message({ message: "正在生成视频...", type: "info" });

        // 准备参数
        const params = {
          userId: userId, // 手机号
          videoId: this.uploadedVideo.id, // 视频ID
          audioId: this.voiceId, // 音频ID
          name: workName, // 作品名称
        };

        console.log("生成视频参数:", params);

        // 调用anchorVideoChatVoiceRetalk接口
        const response = await anchorVideoChatVoiceRetalk(params);

        console.log("生成视频响应:", response);

        if (response && response.data) {
          this.$message({ message: "视频生成成功", type: "success" });

          // 跳转到 records 页面，传递 workId
          this.toRecords("1");
        } else {
          this.$message.error(
            "视频生成失败：" + (response.message || "未知错误")
          );
        }
      } catch (error) {
        console.error("调用生成视频接口失败:", error);
        this.$message.error("视频生成失败，请重试");
      }
    },
    // 隐藏放大视频
    hideLargeVideo() {
      this.showLargeVideoModal = false;
      // 暂停并重置视频
      if (this.$refs.largeVideo) {
        this.$refs.largeVideo.pause();
        this.$refs.largeVideo.currentTime = 0;
      }
    },
  },
  mounted() {
    // 从地址栏获取voiceId参数
    const voiceId = this.$route.query.voiceId;

    console.log("获取到的voiceId:", voiceId);
    this.voiceId = voiceId || "";
    // 严格验证voiceId：不能为undefined、null、空字符串或字符串'undefined'
    this.hasVoiceId = voiceId && voiceId !== "undefined" && voiceId !== "null";
  },
};
</script>

<style scoped>
.kb-video-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: linear-gradient(180deg, #bcdeff 0%, #ffffff 100%);
}

/* 顶部导航栏 */
.nav-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  padding: 0 20px;
  z-index: 1000;
  /* background-color: #ffffff; */
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05); */
}

.back-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  /* z-index: 1000; */
}

.back-icon {
  width: 20px;
  height: 20px;
  color: #000;
}

.nav-title {
  font-size: 18px;
  font-weight: 600;
  color: #000;
}

.nav-actions {
  width: 40px;
  /* 与左侧返回按钮宽度保持一致，确保标题居中 */
}

/* 主要内容区域 */
.content {
  flex: 1;
  padding: 0px 0px 20px 0px;
  overflow-y: auto;
}

.title-section {
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.title-label {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 12px;
}

.title-input-wrapper {
  position: relative;
}

.title-input {
  width: 100%;
  height: 44px;
  padding: 0 50px 0 16px;
  border: 2px solid #e4e7ed;
  border-radius: 8px;
  font-size: 15px;
  color: #303133;
  background: #ffffff;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.title-input:focus {
  border-color: #409eff;
  outline: none;
  box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);
}

.title-input::placeholder {
  color: #c0c4cc;
}

.char-count {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: #909399;
  pointer-events: none;
}
.video {
  width: 100%;
  background: linear-gradient(180deg, #bcdeff 0%, #ffffff 100%);
}

/* 视频添加区域 */
.video-add-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  background-color: #ffffff;
  border-radius: 12px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  margin: 0px 20px;
  height: 200px;
}

/* 视频回显区域 */
.video-preview-section {
  padding: 20px;
  background-color: #ffffff;
  border-radius: 12px;
  margin: 0px 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  height: 200px;
}

.video-preview-wrapper {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease;
  height: 200px;
}

.video-preview-wrapper:hover {
  transform: scale(1.01);
}

.video-preview {
  width: 100%;
  height: 200px;
  border-radius: 8px;
  background-color: #000;
}

.video-info {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.video-name {
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 70%;
}

.video-duration {
  font-size: 12px;
  background-color: rgba(0, 0, 0, 0.6);
  padding: 4px 8px;
  border-radius: 4px;
}

.zoom-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
  transition: all 0.3s ease;
}

.zoom-icon:hover {
  background-color: rgba(0, 0, 0, 0.7);
  transform: scale(1.1);
}

/* 放大视频模态框 */
.large-video-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.large-video-content {
  position: relative;
  width: 90%;
  height: 90%;
  background-color: #000;
  border-radius: 12px;
  overflow: hidden;
}

.large-video-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 16px 20px;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.8), transparent);
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 10;
}

.large-video-title {
  font-size: 18px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80%;
}

.large-video-close {
  font-size: 32px;
  color: #fff;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.large-video-close:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.large-video-body {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.large-video {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.add-video-btn {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #7bc1f8;
  border-radius: 22px;
  margin-bottom: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.add-video-btn:hover {
  background-color: #66b1ff;
  transform: scale(1.05);
}

.plus-icon {
  font-size: 48px;
  color: #ffffff;
  font-weight: bold;
  line-height: 1;
}

.video-tip {
  font-size: 16px;
  color: #303133;
  margin-bottom: 8px;
  font-weight: 500;
}

.video-format {
  font-size: 13px;
  color: #909399;
  text-align: center;
  line-height: 1.4;
}
.mode {
  background-color: #ffffff;
  padding: 40px 20px;
  border-radius: 10px;
  /* height: 100%; */
}

/* 通用章节样式 */
.mode-section,
.voice-section,
.record-section {
  margin-bottom: 20px;
  /* padding: 0px 20px; */
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 14px;
  padding-left: 4px;
  text-align: left;
}

/* 生成模式选项 */
.mode-options {
  display: flex;
  gap: 10px;
  background-color: #ffffff;
  padding: 14px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.mode-option {
  flex: 1;
  padding: 14px 8px;
  text-align: center;
  background-color: #f5f7fa;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}

.mode-option.active {
  background: #c3ddff;
  color: #000;
}

.mode-option:hover:not(.active) {
  background: #c3ddff;
  color: #000;
}

/* 配音选项 */
.voice-options {
  display: flex;
  gap: 10px;
  background-color: #ffffff;
  padding: 14px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.voice-option {
  flex: 1;
  padding: 24px 8px;
  text-align: center;
  background-color: #f5f7fa;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  color: #606266;
  font-weight: 500;
  position: relative;
}

.voice-option:hover {
  background: #c3ddff;
  color: #000;
}

/* 配音状态标签 */
.voice-status {
  position: absolute;
  top: 4px;
  right: 4px;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 8px;
  font-weight: 500;
  z-index: 1;
}

.voice-status.added {
  background-color: #67c23a;
  color: #ffffff;
}

.voice-status.not-added {
  background-color: #f56c6c;
  color: #ffffff;
}

/* 生成记录 */
.record-section {
  background-color: #ffffff;
  padding-top: 20px;
  border-radius: 10px;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); */
  /* min-height: 150px; */
  display: flex;
  flex-direction: column;
}

.record-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  /* margin-bottom: 20px; */
}

.empty-record {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  color: #909399;
}

.empty-icon {
  width: 60px;
  height: 60px;
  margin-bottom: 12px;
  opacity: 0.6;
}

.empty-text {
  font-size: 14px;
}

/* 底部生成按钮 */
.bottom-btn-section {
  padding: 0px 20px 16px 20px;
  background-color: #ffffff;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.05);
}

.generate-btn {
  width: 100%;
  height: 50px;
  font-size: 17px;
  border-radius: 25px;
  background-color: #409eff;
  border: none;
  font-weight: 500;
}

.generate-btn:hover {
  background-color: #66b1ff;
}

/* 视频选择模态框 */
.video-modal {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  /* display: flex;
  align-items: center;
  justify-content: center; */
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  position: relative;
  width: 100%;
  max-width: 400px;
  background-color: #ffffff;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  position: fixed;
  bottom: 0px;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  border-bottom: 1px solid #ebeef5;
}

.modal-title {
  font-size: 17px;
  font-weight: 600;
  color: #303133;
}

.modal-close {
  font-size: 24px;
  color: #909399;
  cursor: pointer;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.modal-close:hover {
  background-color: #f5f7fa;
  color: #606266;
}

.modal-body {
  padding: 20px;
}

.video-format-tip {
  font-size: 13px;
  color: #909399;
  text-align: center;
  margin-bottom: 20px;
  line-height: 1.4;
}

.reference-videos {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-bottom: 10px;
}

.reference-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 120px;
}

.reference-img {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid #e4e7ed;
  margin-bottom: 8px;
}

.reference-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.reference-tag {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.reference-tag img {
  width: 14px;
  height: 14px;
}

.reference-tag.valid {
  background-color: #f0f9eb;
  color: #67c23a;
}

.reference-tag.invalid {
  background-color: #fef0f0;
  color: #f56c6c;
}

.modal-footer {
  display: flex;
  gap: 12px;
  padding: 0 20px 20px;
}

.upload-btn {
  flex: 1;
  height: 45px;
  font-size: 15px;
  border-radius: 22px;
  font-weight: 500;
  background: linear-gradient(90deg, #5ca3f6 0%, rgba(92, 179, 246, 0.8) 100%);
  color: #fff;
  border: none;
}

.upload-btn.cancel {
  background: #000000;
  color: #fff;
  /* border: 1px solid #dcdfe6; */
}

.upload-btn.cancel:hover {
  background-color: #e4e7ed;
  color: #303133;
}
</style>
